import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "button",
    "copy"
  ];

  connect() {
    this.onToggleFAQ();
  }

  onToggleFAQ() {
    this.buttonTarget.addEventListener("click", () => {
      if (this.copyTarget.classList.contains("hidden")) {
        this.copyTarget.classList.remove("hidden");
        this.copyTarget.classList.add("block");
        this.buttonTarget.lastElementChild.innerHTML = "-";
      } else {
        this.copyTarget.classList.remove("block");
        this.copyTarget.classList.add("hidden");
        this.buttonTarget.lastElementChild.innerHTML = "+";
      }
    });
  }
}
